export default __webpack_public_path__ + "static/media/build-community.cac14cdc.png";